import React, { Component } from 'react'
import styles from './style.scss'
import { getConvoName } from '../../../utils/convo'
import moment from 'moment'
import Dropdown from '../../../components/Dropdown'
import { Button } from 'sofia-ui'
import { Query } from "react-apollo";
import gql from "graphql-tag";

import New from '../New'
import List from '../../../components/List'

const QUERY = gql`
query Messages {
  conversations(orderBy: "last_message", order: DESC) {
    id
    _id
    name
    last_message
    tags
    messages (first: 1, order: DESC) {
      id
      _id
      body
    }
    user_conversations {
      id
      user {
        id
        _id
        first_name
        last_name
        phone_number
        email
      }
    }
  }
}
`


class MessagesList extends Component {

  state = {
    filter: 'Inbox',
    add: true
  }

  render() {

    const { filter } = this.state

    return <Query
      query={QUERY}
      variables={{
        cursor: 0,
        limit: 20
      }}
      pollInterval={7500}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return <p>Loading...</p>;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      const convos = data.conversations.filter(({ tags }) => {
        if (filter === "Inbox") return tags.includes('New') || tags.includes('Urgent') || tags.includes('Need followup')
        return tags.includes(filter)
      })
      
      return <React.Fragment>

          <New hide={this.state.add} close={() => this.setState({ add: true })} />

          <List
            header={
              <React.Fragment>
                <Dropdown
                  label={<span><i className="fas fa-filter"></i> {filter}</span>} 
                  options={[{
                    label: "Inbox",
                    value: "Inbox"
                  },{
                    label: "New",
                    value: "New"
                  },{
                    label: "Urgent",
                    value: "Urgent"
                  },{
                    label: "Awaiting Data",
                    value: "Awaiting Data"
                  },{
                    label: "Need followup",
                    value: "Need followup"
                  },{
                    label: "Closed",
                    value: "Closed"
                  },{
                    label: "Development",
                    value: "Development"
                  },{
                    label: "Spam",
                    value: "Spam"
                  },{
                    label: "Old",
                    value: "old"
                  }]}
                  onSelect={filter => this.setState({ filter })}
                  />
                  <Button small color='dark' onClick={() => {
                    console.log('OPEN')
                    this.setState({ add: false })
                  }}>New</Button>
                </React.Fragment>
              }
              list={
                convos.map(({ _id, name, messages, user_conversations, tags, last_message }) => ({
                  link: `/messages/${_id}`,
                  active: _id === this.props.active,
                  title: getConvoName(user_conversations),
                  body: messages[0] && messages[0].body && messages[0].body.substr(0,90)
                    .replace(/(?:\r\n|\r|\n)/g, ' ')
                    .replace(/(?:\t)/g, ' ')
                    .replace(/(?:<br\/>)/g, '')
                    .replace(/( )+/g, ' '),
                  footer: <React.Fragment><small className={styles.date}>{moment(last_message).format("YYYY-MM-DD")}</small> {tags.map((tag, i) => <div className={styles.tag} key={i}>{tag}</div>)}</React.Fragment>
                }))
              }
            />
     
      </React.Fragment>
    }}
    </Query>
  }
}

export default MessagesList;



// WEBPACK FOOTER //
// ./src/containers/messages/List/index.js